// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-EcVMQ {\n  position: relative;\n}\n.suggestionContainer-9GdBi {\n  position: absolute;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  border: 1px solid #ccd0d3;\n  background-color: #fff;\n  box-sizing: border-box;\n  z-index: 2;\n  display: none;\n}\n.suggestion-qD47m {\n  white-space: nowrap;\n  cursor: pointer;\n  height: 22px;\n}\n.suggestion-qD47m > span {\n  margin-left: 5px;\n  margin-bottom: 4px;\n  white-space: nowrap !important;\n  overflow: hidden;\n  margin-right: 5px;\n}\n.suggestionHighlighted-Jgb9K {\n  background-color: #ccd0d3;\n}\n.containerOpen-kWtqj .suggestionContainer-9GdBi {\n  display: block;\n}\n.sectionContainer-YVMtJ {\n  position: relative;\n  border-bottom: 1px dashed #ccd0d3;\n  max-height: 400px;\n  overflow: auto;\n  padding: 5px 0;\n}\n.sectionContainer-YVMtJ:last-child {\n  border-bottom: none;\n}\n.sectionTitle-LNWJC {\n  white-space: nowrap;\n  height: 22px;\n  margin-left: 5px;\n  margin-bottom: 4px;\n  margin-right: 5px;\n}\n.suggestionsList-wl0bW {\n  width: 100%;\n  margin: 0;\n  padding: 5px 0;\n  list-style-type: none;\n  background-color: #fff;\n  box-sizing: border-box;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/form-controls/inputs/autosuggest-input/autosuggest-input.less"],"names":[],"mappings":"AAEA;EAEI,kBAAA;AA8GJ;AAhHA;EAMI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;AA6GJ;AA5HA;EAmBI,mBAAA;EACA,eAAA;EACA,YAAA;AA4GJ;AAjIA;EAuBM,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;AA6GN;AAxIA;EAgCI,yBAAA;AA2GJ;AA3IA;EAqCM,cAAA;AAyGN;AA9IA;EA0CI,kBAAA;EACA,iCAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAuGJ;AArGI;EACE,mBAAA;AAuGN;AAxJA;EAsDI,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAqGJ;AA/JA;EA8DI,WAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;AAoGJ","sourcesContent":["@import 'variables';\n\n:local {\n  .container {\n    position: relative;\n  }\n\n  .suggestionContainer {\n    position: absolute;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n    border: 1px solid @suggestion-container-border-color;\n    background-color: @suggestion-container-bg-color;\n    box-sizing: border-box;\n    z-index: 2;\n    display: none;\n  }\n\n  .suggestion {\n    white-space: nowrap;\n    cursor: pointer;\n    height: 22px;\n    > span {\n      margin-left: 5px;\n      margin-bottom: 4px;\n      white-space: nowrap !important;\n      overflow: hidden;\n      margin-right: 5px;\n    }\n  }\n\n  .suggestionHighlighted {\n    background-color: @suggestion-container-border-color;\n  }\n\n  .containerOpen {\n    .suggestionContainer {\n      display: block;\n    }\n  }\n\n  .sectionContainer {\n    position: relative;\n    border-bottom: 1px dashed @suggestion-container-border-color;\n    max-height: 400px;\n    overflow: auto;\n    padding: 5px 0;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .sectionTitle {\n    white-space: nowrap;\n    height: 22px;\n    margin-left: 5px;\n    margin-bottom: 4px;\n    margin-right: 5px;\n  }\n\n  .suggestionsList {\n    width: 100%;\n    margin: 0;\n    padding: 5px 0;\n    list-style-type: none;\n    background-color: @suggestion-container-bg-color;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"container": "container-EcVMQ",
	"suggestionContainer": "suggestionContainer-9GdBi",
	"suggestion": "suggestion-qD47m",
	"suggestionHighlighted": "suggestionHighlighted-Jgb9K",
	"containerOpen": "containerOpen-kWtqj",
	"sectionContainer": "sectionContainer-YVMtJ",
	"sectionTitle": "sectionTitle-LNWJC",
	"suggestionsList": "suggestionsList-wl0bW"
};
export default ___CSS_LOADER_EXPORT___;
